import { Sidebar } from './Sidebar';
import { Header } from './Header';

export const DashboardLayout = ({ children, title }) => {
  const headline = typeof title === 'string' && title.trim() !== '' ? title : '';

  return (
    <div
      className="min-h-screen bg-background"
      data-testid="dashboard-layout"
      style={{ backgroundColor: 'hsl(var(--background))' }}
    >
      <Sidebar />
      <div className="pl-64">
        <Header />
        <main style={{ backgroundColor: 'hsl(var(--background))' }}>
          {headline !== '' && (
            <div style={{ padding: '26px 26px 20px 26px' }} data-testid="page-headline">
              <h1 style={{
                fontFamily: 'var(--font-display)',
                fontStyle: 'italic',
                fontWeight: 800,
                textTransform: 'uppercase',
                letterSpacing: 'var(--ls-tight)',
                fontSize: 30,
                margin: 0,
                color: 'var(--text)'
              }}>{headline}</h1>
            </div>
          )}
          <div style={{ padding: '0 26px 26px 26px' }}>
            {children}
          </div>
        </main>
      </div>
    </div>
  );
};
